var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-building" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("branch")) + "\n        ")
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "q-chips-input",
              {
                ref: "companies_label",
                attrs: {
                  "float-label": _vm.$t("headquarter"),
                  error: _vm.$v.companies_label.$error,
                  disable: _vm.$route.params.id_company ? true : false,
                  filter: "",
                  "autofocus-filter": ""
                },
                on: {
                  input: _vm.$v.companies_label.$touch,
                  remove: _vm.removeHeadquarter
                },
                model: {
                  value: _vm.companies_label,
                  callback: function($$v) {
                    _vm.companies_label = $$v
                  },
                  expression: "companies_label"
                }
              },
              [
                _c("q-autocomplete", {
                  attrs: { "min-characters": 1, "max-results": 100 },
                  on: {
                    search: _vm.fetchHeadquarters,
                    selected: _vm.selectHeadquarter
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "q-field",
              { attrs: { count: 140 } },
              [
                _c("q-input", {
                  ref: "name",
                  attrs: {
                    "float-label": _vm.$t("name"),
                    error: _vm.$v.name.$error
                  },
                  on: { input: _vm.$v.name.$touch },
                  model: {
                    value: _vm.name,
                    callback: function($$v) {
                      _vm.name = $$v
                    },
                    expression: "name"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "q-field",
              { attrs: { count: 140 } },
              [
                _c("q-input", {
                  ref: "fantasy",
                  attrs: {
                    "float-label": _vm.$t("fantasy_name"),
                    error: _vm.$v.fantasy.$error
                  },
                  on: { input: _vm.$v.fantasy.$touch },
                  model: {
                    value: _vm.fantasy,
                    callback: function($$v) {
                      _vm.fantasy = $$v
                    },
                    expression: "fantasy"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-input", {
              ref: "document",
              attrs: {
                color: _vm.document_error ? "danger" : "primary",
                "float-label": _vm.$t("store_document")
              },
              on: {
                blur: function($event) {
                  return _vm.documentUnique()
                }
              },
              model: {
                value: _vm.document,
                callback: function($$v) {
                  _vm.document = $$v
                },
                expression: "document"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-input", {
              ref: "register",
              attrs: { "float-label": _vm.$t("register_number") },
              on: {
                blur: function($event) {
                  return _vm.registerUnique()
                }
              },
              model: {
                value: _vm.register,
                callback: function($$v) {
                  _vm.register = $$v
                },
                expression: "register"
              }
            })
          ],
          1
        ),
        _vm.register_error && _vm.id_branch
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    size: "small",
                    label: _vm.$t("edit_branch_found"),
                    icon: "fal fa-edit"
                  },
                  on: {
                    click: function($event) {
                      return _vm.openBranch()
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.document_error && _vm.id_branch
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    size: "small",
                    label: _vm.$t("edit_branch_found"),
                    icon: "fal fa-edit"
                  },
                  on: {
                    click: function($event) {
                      return _vm.openBranch()
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-select", {
              attrs: {
                filter: "",
                "autofocus-filter": "",
                options: _vm.branch_types,
                "float-label": _vm.$t("branch_type"),
                clearable: ""
              },
              model: {
                value: _vm.branch_type,
                callback: function($$v) {
                  _vm.branch_type = $$v
                },
                expression: "branch_type"
              }
            })
          ],
          1
        ),
        _vm.current_client === "chevrolet"
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c("q-select", {
                  attrs: {
                    options: _vm.branch_size_types,
                    "float-label": _vm.$t("branch_size_types")
                  },
                  model: {
                    value: _vm.branch_size_type,
                    callback: function($$v) {
                      _vm.branch_size_type = $$v
                    },
                    expression: "branch_size_type"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-select", {
              attrs: {
                filter: "",
                "autofocus-filter": "",
                options: _vm.regionals,
                "float-label": _vm.$t("regional"),
                clearable: ""
              },
              model: {
                value: _vm.regional,
                callback: function($$v) {
                  _vm.regional = $$v
                },
                expression: "regional"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-select", {
              ref: "country",
              attrs: {
                filter: "",
                "autofocus-filter": "",
                options: _vm.countries,
                "float-label": _vm.$t("country"),
                error: _vm.$v.country.$error
              },
              on: { input: _vm.$v.country.$touch },
              model: {
                value: _vm.country,
                callback: function($$v) {
                  _vm.country = $$v
                },
                expression: "country"
              }
            })
          ],
          1
        ),
        _vm.keyGooogleMaps
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c(
                  "q-field",
                  {
                    attrs: {
                      error: _vm.show_maps_alert,
                      "error-label": _vm.$t(
                        "not_found_check_that_the_search_is_spelled_correctly_and_try_to_add_a_street_address_and_the_number_of_valid_addresses"
                      )
                    }
                  },
                  [
                    _c(
                      "q-input",
                      {
                        ref: "address",
                        attrs: {
                          "float-label": _vm.$t("address"),
                          autocomplete: "new-password",
                          error: _vm.$v.address.$error,
                          placeholder: _vm.$t(
                            "search_by_name_and_street_number"
                          )
                        },
                        on: { input: _vm.$v.address.$touch },
                        model: {
                          value: _vm.address,
                          callback: function($$v) {
                            _vm.address = $$v
                          },
                          expression: "address"
                        }
                      },
                      [
                        _c("q-autocomplete", {
                          attrs: { "min-characters": 3, separator: "" },
                          on: {
                            search: _vm.getAddressGoogleMaps,
                            selected: _vm.selectedAddressGoogleMaps
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c(
                  "q-input",
                  {
                    attrs: {
                      "float-label": _vm.$t("address"),
                      autocomplete: "new-password",
                      error: _vm.$v.address.$error
                    },
                    on: { input: _vm.$v.address.$touch },
                    model: {
                      value: _vm.address,
                      callback: function($$v) {
                        _vm.address = $$v
                      },
                      expression: "address"
                    }
                  },
                  [
                    _c("q-autocomplete", {
                      attrs: { "min-characters": 3, separator: "" },
                      on: {
                        search: _vm.getAddress,
                        selected: _vm.selectedAddress
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              ref: "number",
              attrs: { "float-label": _vm.$t("number") },
              model: {
                value: _vm.number,
                callback: function($$v) {
                  _vm.number = $$v
                },
                expression: "number"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: { "float-label": _vm.$t("complement") },
              model: {
                value: _vm.complement,
                callback: function($$v) {
                  _vm.complement = $$v
                },
                expression: "complement"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: { "float-label": _vm.$t("neighborhood") },
              model: {
                value: _vm.neighborhood,
                callback: function($$v) {
                  _vm.neighborhood = $$v
                },
                expression: "neighborhood"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: { "float-label": _vm.$t("postal_code") },
              model: {
                value: _vm.postal_code,
                callback: function($$v) {
                  _vm.postal_code = $$v
                },
                expression: "postal_code"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              ref: "city",
              attrs: {
                "float-label": _vm.$t("city"),
                error: _vm.$v.city.$error
              },
              on: { input: _vm.$v.city.$touch },
              model: {
                value: _vm.city,
                callback: function($$v) {
                  _vm.city = $$v
                },
                expression: "city"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              ref: "state",
              attrs: {
                "float-label": _vm.$t("state"),
                error: _vm.$v.state.$error
              },
              on: { input: _vm.$v.state.$touch },
              model: {
                value: _vm.state,
                callback: function($$v) {
                  _vm.state = $$v
                },
                expression: "state"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: { type: "number", "float-label": _vm.$t("latitude") },
              model: {
                value: _vm.lat,
                callback: function($$v) {
                  _vm.lat = $$v
                },
                expression: "lat"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4" },
          [
            _c("q-input", {
              attrs: { type: "number", "float-label": _vm.$t("longitude") },
              model: {
                value: _vm.long,
                callback: function($$v) {
                  _vm.long = $$v
                },
                expression: "long"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-4 flex  items-end justify-center" },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                disabled: _vm.disabledButton,
                color: "primary",
                icon: "map",
                label: "Ver no mapa"
              },
              on: {
                click: function($event) {
                  return _vm.showMap()
                }
              }
            })
          ],
          1
        ),
        _vm.current_client === "chevrolet"
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: { type: "text", "float-label": _vm.$t("region") },
                  model: {
                    value: _vm.regional_name,
                    callback: function($$v) {
                      _vm.regional_name = $$v
                    },
                    expression: "regional_name"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.current_client === "chevrolet"
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: { type: "email", "float-label": _vm.$t("area_email") },
                  model: {
                    value: _vm.area_email,
                    callback: function($$v) {
                      _vm.area_email = $$v
                    },
                    expression: "area_email"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.current_client === "chevrolet"
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: { type: "tel", "float-label": _vm.$t("phone_number") },
                  model: {
                    value: _vm.phone_number,
                    callback: function($$v) {
                      _vm.phone_number = $$v
                    },
                    expression: "phone_number"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.current_client === "chevrolet"
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: {
                    type: "text",
                    "float-label": _vm.$t("operational_area")
                  },
                  model: {
                    value: _vm.operational_area,
                    callback: function($$v) {
                      _vm.operational_area = $$v
                    },
                    expression: "operational_area"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.current_client === "chevrolet"
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: { type: "text", "float-label": _vm.$t("division") },
                  model: {
                    value: _vm.division,
                    callback: function($$v) {
                      _vm.division = $$v
                    },
                    expression: "division"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.current_client === "chevrolet"
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-4" },
              [
                _c("q-input", {
                  attrs: { type: "text", "float-label": _vm.$t("district") },
                  model: {
                    value: _vm.district,
                    callback: function($$v) {
                      _vm.district = $$v
                    },
                    expression: "district"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.current_client === "chevrolet"
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-datetime", {
                  attrs: {
                    type: "datetime",
                    "float-label": _vm.$t("opened_date"),
                    format: "DD/MM/YYYY"
                  },
                  model: {
                    value: _vm.opened_date,
                    callback: function($$v) {
                      _vm.opened_date = $$v
                    },
                    expression: "opened_date"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.current_client === "chevrolet"
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("q-datetime", {
                  attrs: {
                    type: "datetime",
                    "float-label": _vm.$t("closed_date"),
                    format: "DD/MM/YYYY"
                  },
                  model: {
                    value: _vm.closed_date,
                    callback: function($$v) {
                      _vm.closed_date = $$v
                    },
                    expression: "closed_date"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-select", {
              ref: "client",
              attrs: {
                filter: "",
                "autofocus-filter": "",
                multiple: "",
                options: _vm.clients,
                chips: "",
                "float-label": _vm.$t("clients"),
                error: _vm.$v.client.$error
              },
              on: { input: _vm.$v.client.$touch },
              model: {
                value: _vm.client,
                callback: function($$v) {
                  _vm.client = $$v
                },
                expression: "client"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 q-mt-sm" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("areas")))
            ]),
            _c("q-checkbox", {
              staticClass: "q-mb-xs",
              attrs: {
                disable: !_vm.client.length,
                val: true,
                label: _vm.$t("select_all_areas")
              },
              on: {
                input: function($event) {
                  return _vm.checkAllAreas()
                }
              },
              model: {
                value: _vm.all_areas,
                callback: function($$v) {
                  _vm.all_areas = $$v
                },
                expression: "all_areas"
              }
            }),
            _c("q-select", {
              ref: "area",
              attrs: {
                filter: "",
                "autofocus-filter": "",
                options: _vm.filtered_areas,
                multiple: "",
                chips: "",
                error: _vm.$v.area.$error
              },
              on: { input: _vm.$v.area.$touch },
              model: {
                value: _vm.area,
                callback: function($$v) {
                  _vm.area = $$v
                },
                expression: "area"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _vm.isVivara
              ? _c(
                  "q-chips-input",
                  {
                    attrs: { "float-label": _vm.$t("managers_general") },
                    on: { remove: _vm.removeOwnerGeneral },
                    model: {
                      value: _vm.managers_general_list,
                      callback: function($$v) {
                        _vm.managers_general_list = $$v
                      },
                      expression: "managers_general_list"
                    }
                  },
                  [
                    _c("q-autocomplete", {
                      attrs: {
                        "min-characters": 3,
                        "value-field": function(v) {
                          return v.full_name + " - " + v.email
                        }
                      },
                      on: {
                        search: _vm.searchOwnerGeneral,
                        selected: _vm.selectOwnerGeneral
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _vm.isVivara
              ? _c(
                  "q-chips-input",
                  {
                    attrs: { "float-label": _vm.$t("managers_regional") },
                    on: { remove: _vm.removeOwnerRegional },
                    model: {
                      value: _vm.managers_regional_list,
                      callback: function($$v) {
                        _vm.managers_regional_list = $$v
                      },
                      expression: "managers_regional_list"
                    }
                  },
                  [
                    _c("q-autocomplete", {
                      attrs: {
                        "min-characters": 3,
                        "value-field": function(v) {
                          return v.full_name + " - " + v.email
                        }
                      },
                      on: {
                        search: _vm.searchOwnerRegional,
                        selected: _vm.selectOwnerRegional
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "q-chips-input",
              {
                attrs: { "float-label": _vm.$t("managers") },
                on: { remove: _vm.removeOwner },
                model: {
                  value: _vm.managers_list,
                  callback: function($$v) {
                    _vm.managers_list = $$v
                  },
                  expression: "managers_list"
                }
              },
              [
                _c("q-autocomplete", {
                  attrs: {
                    "min-characters": 3,
                    "value-field": function(v) {
                      return v.full_name + " - " + v.email
                    }
                  },
                  on: { search: _vm.searchOwner, selected: _vm.selectOwner }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("status")))
            ]),
            _c("q-btn-toggle", {
              attrs: {
                "toggle-color": _vm.getColorStatus,
                options: _vm.statuses
              },
              model: {
                value: _vm.status,
                callback: function($$v) {
                  _vm.status = $$v
                },
                expression: "status"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "q-display-1 q-mt-lg text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-users" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("users")) + "\n        ")
        ],
        1
      ),
      _vm.id ? _c("users", { attrs: { id: _vm.id } }) : _vm._e(),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.backBranch()
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }